<input #uploadInput [hidden]="true" id="input-file-id" type="file" [accept]="accept" (change)="onFileSubmitted(uploadInput.files)" />
<button color="primary" for="input-file-id" mat-flat-button (click)="uploadInput.click()">{{label}}</button>
